require("select2/dist/js/select2.full.js")
require("select2/dist/js/i18n/de.js")
require("select2/dist/css/select2.css")

import { Component, ElementRef, Input, OnChanges, Optional, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

declare var jQuery: any;

@Component({
	selector: 'combobox',
	templateUrl: "./combobox.html",
	styles: [require("./combobox.scss")],
	encapsulation: ViewEncapsulation.None

})
export class Combobox implements ControlValueAccessor, OnChanges {
	private select2: any;
	private el;
	private tempValue: string

	@Input() minimumInputLength: number = 3;
	@Input() data: Array<{id: string, text: string, html: string}>;
	@Input() displayHtml: boolean;

	constructor(@Optional() private ngFormControl: NgControl, private elementRef: ElementRef) {
		ngFormControl.valueAccessor = this;
	}

	ngOnChanges() {
		this.el = jQuery(this.elementRef.nativeElement).find("select");
		// Empty option needed for placeholder to work
		this.el.append(jQuery('<option></option>'));

		let select2Config = {
			language: 'de',
			minimumInputLength: this.minimumInputLength,
			placeholder: "Auswahl",
			data: this.data,
			allowClear: true
		}

		if (this.displayHtml  && this.data) {
			select2Config['templateResult'] = data => data.html;
			select2Config['templateSelection'] = data => data.text;
			select2Config['escapeMarkup'] = markup => markup;
		}

		this.rerender(this.tempValue);
		this.select2 = this.el.select2(select2Config);

		this.select2.on("select2:close", (e) => {
			this.updateControlValueAccessor(this.el.val())
			this.updateCss()
		})
		//Prevent Dropdown from opening on unselect
		this.select2.on('select2:opening', (e) => {
			if (this.el.data('unselecting')) {
				this.el.removeData('unselecting');
				e.preventDefault();
				this.updateControlValueAccessor(this.el.val())
			}
		}).on('select2:unselecting', (e) => {
			this.el.data('unselecting', true);

		});
	}

	writeValue(id: string): void {
		this.tempValue = id;
		this.setSelectedOption(id)

		// damit das select2 sich aktualisiert, muss auf dem select2 change getriggert werden
		// siehe https://github.com/select2/select2/issues/3554
		if (this.el) {
			this.select2.trigger('change')
		}
	}

	registerOnChange(fn: any): void {
		this.controlValueAccessorChanged = fn;
	}

	registerOnTouched(fn: any): void {
		this.controlValueAccessorTouched = fn;
	}

	private controlValueAccessorChanged = (_) => {};
	private controlValueAccessorTouched = () => {};

	private updateControlValueAccessor(optionId: string) {
		this.controlValueAccessorTouched();
		if (!optionId) {
			this.controlValueAccessorChanged(null);
			return;
		}
		this.controlValueAccessorChanged(optionId);
	}

	private updateCss() {
		if (this.ngFormControl.dirty && !this.ngFormControl.valid) {
			jQuery(this.elementRef.nativeElement).find(".select2-selection").attr("class", "select2-selection select2-selection--single invalid")
		} else {
			jQuery(this.elementRef.nativeElement).find(".select2-selection").attr("class", "select2-selection select2-selection--single")
		}
	}

	private setSelectedOption(id: string) {
		if (id && this.data) {
			let option = jQuery('<option selected></option>')
			let dataElement = this.data.find(element => element.id === id)
			if (dataElement) {
				option.text(dataElement.text)
				option.val(id)
				this.el.append(option)
			}
		}
	}

	private rerender(tempValue: string){
		if(tempValue){
			this.setSelectedOption(this.tempValue)
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/ui-helper/combobox/combobox.component.ts